import {
  METRICS_GROUP_ADMIN_GET_LIST_INIT,
  METRICS_GROUP_ADMIN_GET_LIST_SUCCESS,
  METRICS_GROUP_ADMIN_GET_LIST_FAILURE,
  METRICS_GROUP_ADMIN_GET_METRICS_LIST_INIT,
  METRICS_GROUP_ADMIN_GET_METRICS_LIST_SUCCESS,
  METRICS_GROUP_ADMIN_GET_METRICS_LIST_FAILURE,
  METRICS_GROUP_ADMIN_SAVE_INIT,
  METRICS_GROUP_ADMIN_SAVE_SUCCESS,
  METRICS_GROUP_ADMIN_SAVE_FAILURE,
  METRICS_GROUP_ADMIN_DELETE_INIT,
  METRICS_GROUP_ADMIN_DELETE_PREPARE_INIT,
  METRICS_GROUP_ADMIN_DELETE_SUCCESS,
  METRICS_GROUP_ADMIN_DELETE_FAILURE,
  METRICS_GROUP_ADMIN_SET_SAVE_DATA_BY_KEY,
  METRICS_GROUP_ADMIN_SAVE_RESET,
  METRICS_GROUP_ADMIN_GET_TAGS_LIST_INIT,
  METRICS_GROUP_ADMIN_GET_TAGS_LIST_SUCCESS,
  METRICS_GROUP_ADMIN_GET_TAGS_LIST_FAILURE,
  METRICS_GROUP_ADMIN_RESET
} from './types';
import Constants from '../../../definitions/constants';
import ActionsTooling from '../../../tooling/actionsTooling';

export function reset() {
  return {
    type: METRICS_GROUP_ADMIN_RESET
  };
}

export function getList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRICS_GROUP_ADMIN_GET_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metricsgroup/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRICS_GROUP_ADMIN_GET_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRICS_GROUP_ADMIN_GET_LIST_FAILURE, error));
    }  
  };
}

export function getMetricsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRICS_GROUP_ADMIN_GET_METRICS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRICS_GROUP_ADMIN_GET_METRICS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRICS_GROUP_ADMIN_GET_METRICS_LIST_FAILURE, error));
    }  
  };
}

export function saveEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRICS_GROUP_ADMIN_SAVE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metricsgroup/save",
        "POST",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRICS_GROUP_ADMIN_SAVE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRICS_GROUP_ADMIN_SAVE_FAILURE, error));
    }  
  };
}

export function setSaveEntityDataByKey(key, value) {
  return {
    type: METRICS_GROUP_ADMIN_SET_SAVE_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetSaveEntity(data) {
  return {
    type: METRICS_GROUP_ADMIN_SAVE_RESET,
    data: data 
  };
}

export function prepareDeleteEntity(id) {
  return {
    type: METRICS_GROUP_ADMIN_DELETE_PREPARE_INIT,
    id: id
  };
}

export function deleteEntity(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRICS_GROUP_ADMIN_DELETE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metricsgroup/delete",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRICS_GROUP_ADMIN_DELETE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRICS_GROUP_ADMIN_DELETE_FAILURE, error));
    }  
  };
}

export function getTagsList() {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRICS_GROUP_ADMIN_GET_TAGS_LIST_INIT,
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/tags/getlist",
        "POST",
        null,
        null,
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRICS_GROUP_ADMIN_GET_TAGS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRICS_GROUP_ADMIN_GET_TAGS_LIST_FAILURE, error));
    }  
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/metricsGroupAdmin/index.js